import React from 'react';
import {
  NextLevelCategoryTree,
  NextLevelCategoryTreeProps,
} from './CategoryTreeNavigationItem';

export const SecondLevelCategoryTree: React.FC<
  Omit<NextLevelCategoryTreeProps, 'testId' | 'categoryParent'>
> = props => {
  return (
    <NextLevelCategoryTree testId="secondLevelCategoryNavigation" {...props} />
  );
};
